import React, { Component } from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { connect } from "react-redux";

import {
  WORD_ICON,
  TEXT_ICON,
  PDF_ICON,
  EXCEL_ICON,
} from "../../../../../../assets/js/image";
import Dropzone from "./Dropzone/Dropzone";
import Cookie from "js-cookie";
import "./Uploadwindow.css";
import {
  httpGetVendorStatusDetails,
  httpPostFileUpload,
} from "../../../../../../service/httpClient";
import { Form } from "react-bootstrap";
import { extractVendorStatus } from "../../../../OnboardingContainer";
import { updateServiceData } from "../../../../../../redux/serviceSlice";
import { updateCommonInfo } from "../../../../../../redux/commonSlice";
import DocumentUploadFileSizeErrorModal from "../DocumentUploadFileSizeErrorModal";
import * as Constants from "../../../../../../constants/Constants";
import Cookies from "js-cookie";
import { checkOnBoardingStatus } from "../../../../../../utils/utils";
import { getUserRolePermission } from "../../../../../../utils/rolePermissionAccess";
import * as rolePermConsts from "../../../../../../constants/RolePermissionConstants";
import { ToolTip } from "../../../../../Common/Tooltip/ToolTip";
import "../../../../../Common/Tooltip/ToolTip.css";
import { isValidateDateField } from "../../../../OnboardingHelper";
let formData = new FormData();
const fileSizeLimit = 52428800; // 50MB
let isAllowToShowExipryDate = null;

class Uploadwindow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      newFile: {},
      disabled: false,
      successfullUploaded: false,
      selectValue: "",
      selectedValue: [],
      finalUpload: [],
      userMessage: false,
      errMessage: "",
      selectDocument: [],
      extensionFlag: false,
      disableUploadButton: false,
      showFileSizeErrorModal: false,
      expirationDate: "",
      expirationErrorMsg: "",
    };

    this.uploadFilesBtn = this.uploadFilesBtn.bind(this);
    this.replaceFiles = this.replaceFiles.bind(this);
    this.cancelButton = this.cancelButton.bind(this);
    isAllowToShowExipryDate = getUserRolePermission(
      rolePermConsts.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
      rolePermConsts.EXPIRATION_DATE
    );
  }

  onFilesAdded = (files) => {
    if (this.state.selectValue === "") {
      this.setState({ errMessage: "Please select the value from drop down" });
      return;
    }

    if (this.state.selectValue !== "") {
      this.setState({ newFile: files, errMessage: "" });

      const fileCheck = this.duplicateCheck(files);
      const extension = [
        ".doc",
        ".DOC",
        ".docx",
        ".DOCX",
        ".jpg",
        ".JPG",
        ".jpeg",
        ".JPEG",
        ".png",
        ".PNG",
        ".odt",
        ".ODT",
        ".pdf",
        ".PDF",
        ".xls",
        ".XLS",
        ".xlsx",
        ".XLSX",
        ".xlsm",
        ".XLSM",
      ];
      const extFlag = extension.some((el) => files?.name.endsWith(el));

      if (!extFlag) this.setState({ extensionFlag: true });

      if (fileCheck && extFlag) {
        this.setState((prevState) => ({
          files: prevState.files.concat(files),
          selectedValue: prevState.selectedValue.concat(this.state.selectValue),
        }));
      }
    }
  };

  duplicateCheck(files) {
    let fileCheck = true;
    const deft = [...this.state.files];
    const val = [...this.state.selectedValue];

    if (deft.length > 0) {
      for (let i = 0; i < deft.length; i++) {
        if (deft[i].name === files.name && val[i] === this.state.selectValue) {
          this.setState({ userMessage: true, disabled: true });
          return (fileCheck = false);
        }
      }
    }
    return fileCheck;
  }

  uploadFilesBtn() {
    this.setState({ disableUploadButton: true }, () => {
      if (!formData.has("email")) {
        formData.append("email", Cookie.get("email"));
      }

      if (!formData.has("duns")) {
        formData.append("duns", this.props.duns);
      } else {
        formData.delete("duns");
        formData.append("duns", this.props.duns);
      }

      if (!formData.has("vendorId")) {
        formData.append("vendorId", this.props.vendorId);
      } else {
        formData.delete("vendorId");
        formData.append("vendorId", this.props.vendorId);
      }

      if (!formData.has("vendorName")) {
        formData.append("vendorName", this.props.vendorName);
      } else {
        formData.delete("vendorName");
        formData.append("vendorName", this.props.vendorName);
      }
      if (!formData.has("expirationDate")) {
        formData.append("expirationDate", this.state.expirationDate);
      } else {
        formData.delete("expirationDate");
        formData.append("expirationDate", this.state.expirationDate);
      }

      let sizeFlag = true;
      for (let i = 0; i < this.state.files.length; i++) {
        if (this.state.files[i].size > fileSizeLimit) {
          sizeFlag = false;
        } else {
          formData.append(this.state.selectedValue[i], this.state.files[i]);
        }
      }

      const { updateServiceData, updateCommonInfo, dispatch } = this.props;

      if (this.state.files && sizeFlag === true) {
        this.props.setFetching(true);
        httpPostFileUpload(formData)
          .then((response) => {
            this.setState({
              files: [],
              selectedValue: [],
              userMessage: false,
              disabled: false,
              selectValue: "",
              errMessage: "",
              successfullUploaded: true,
              selectDocument: [],
              disableUploadButton: false,
            });
            Array.from(formData.keys()).forEach((key) => formData.delete(key));
            this.props.fetchData(this.props.vendorId);
            httpGetVendorStatusDetails(this.props.vendorId)
              .then((res) => {
                const { mutatedVendorStatus } = extractVendorStatus(
                  this.props.vendorDetails.status,
                  res.data
                );
                updateServiceData({ vendorStatus: res.data });
                updateCommonInfo({ boardingStatuses: mutatedVendorStatus });
              })
              .catch((error) => {
                console.log("Error in Document Center Page: ", error);
              });

            this.props.onHide();
          })
          .catch((error) => {
            this.setState({
              files: [],
              selectedValue: [],
              userMessage: false,
              disabled: false,
              selectValue: "",
              errMessage: "",
              successfullUploaded: true,
              selectDocument: [],
              disableUploadButton: false,
            });
            Array.from(formData.keys()).forEach((key) => formData.delete(key));
            this.props.onHide();
            this.props.setFetching(false);
          });
      } else {
        this.setState({
          disableUploadButton: false,
          showFileSizeErrorModal: true,
        });
      }
    });
  }

  filevalue = (e, category) => {
    if (category === "Document Category") {
      const categoryDocument = e?.target?.value;
      let selectDocumentList = [];

      this.setState({ selectDocument: [], selectValue: "" }, () => {
        if (categoryDocument === "AccountsPayableDocuments") {
          const { vendorDetail = {} } = this.props.vendorProfile || {};
          const {
            merchandiseType = "",
            certifiedAsMinority,
            isPrimaryVendor,
            isAffidavit,
          } = vendorDetail;
          const isMandatoryCriteria =
            merchandiseType !== Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
            isPrimaryVendor &&
            certifiedAsMinority &&
            !isAffidavit;
          selectDocumentList = [
            { value: "BlankInvoice", label: "Blank Invoice" },
            { value: "CompanyLetterhead", label: "Company Letterhead" },
            { value: "ComplianceLetter", label: "Compliance Letter" },
            { value: "ContinuingGuaranty", label: "Continuing Guaranty" },
            {
              value: "W9",
              label: "W9",
            },
          ];

          if (
            isMandatoryCriteria ||
            this.props?.vendorDetails?.merchandiseType !==
              Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE
          ) {
            selectDocumentList.push({
              value: "MinorityBusinessDocumentation",
              label: "MBE/WBE Business Documentation",
            });
          }

          this.setState({ selectDocument: selectDocumentList });
        } else if (categoryDocument === "PreboardingDocuments") {
          selectDocumentList = [
            { value: "SignedVDFContract", label: "Signed VDF Contract" },
            {
              value: "UPSShippingInformation",
              label: "UPS Shipping Information",
            },
            { value: "GS1Certification", label: "GS1 Certification" },
            { value: "UCC128Label", label: "UCC128 Label" },
          ];
          if (
            this.rolePermissionForChannelProfitCalculator() ===
            rolePermConsts.EDIT
          ) {
            selectDocumentList.push({
              value: "ChannelProfitCalculator",
              label: "Channel Profit Calculator",
            });
          }
          this.setState({ selectDocument: selectDocumentList });
        } else if (categoryDocument === "IntegrationDocuments") {
          selectDocumentList = [
            { value: "PackingSlip", label: "Packing Slip" },
            { value: "ShippingLabel", label: "Shipping Label" },
            { value: "VLL", label: "VLL" },
            { value: "TestUPCDocument", label: "Test UPC Document" },
            { value: "Images", label: "Images" },
          ];

          this.setState({ selectDocument: selectDocumentList });
        } else if (categoryDocument === "MiscDocuments") {
          if (Cookies.get(Constants.USER_TYPE) === Constants.EXTERNAL_UI) {
            selectDocumentList = [
              {
                value: "BrandMappingTemplate",
                label: "Brand Mapping Template",
              },
              {
                value: "VDFLegacyRequestForm",
                label: "VDF Legacy Request Form",
              },
              { value: "Other", label: "Other" },
            ];
            this.setState({ selectDocument: selectDocumentList });
          } else {
            selectDocumentList = [
              {
                value: "BrandMappingTemplate",
                label: "Brand Mapping Template",
              },
              {
                value: "VDFLegacyRequestForm",
                label: "VDF Legacy Request Form",
              },
              {
                value: "FreightTermsExplanation",
                label: "Freight Terms Explanation",
              },
              { value: "Other", label: "Other" },
            ];
            if (
              this.rolePermissionForAddDocumentConsignmentContractFirstDraft() ===
                rolePermConsts.EDIT &&
              checkOnBoardingStatus(this.props.onboardingStatus, [
                Constants.DOCUMENT_SUBMITTED,
                Constants.CONSIGNMENT_ADMIN_PENDING,
                Constants.ACCOUNTS_PAYABLE_VP_PENDING,
                Constants.DBM_APPROVED,
              ])
            ) {
              selectDocumentList.splice(3, 0, {
                value: "ConsignmentContractFirstDraft",
                label: "Consignment Contract First Draft",
              });
            }
            if (
              getUserRolePermission(
                rolePermConsts.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
                rolePermConsts.VMS_CONSIGNMENT_FINAL_CONTRACT
              ) === rolePermConsts.EDIT &&
              checkOnBoardingStatus(this.props.onboardingStatus, [
                Constants.DOCUMENT_SUBMITTED,
                Constants.CONSIGNMENT_ADMIN_PENDING,
                Constants.ACCOUNTS_PAYABLE_VP_PENDING,
                Constants.DBM_APPROVED,
              ])
            ) {
              selectDocumentList.splice(3, 0, {
                value: "ConsignmentContractFinaltDraft",
                label: "Consignment Contract Final Draft",
              });
            }

            this.setState({ selectDocument: selectDocumentList });
          }
        }
      });
    } else if (category === "Select Document") {
      this.setState({ errMessage: "" });
      this.setState({ selectValue: e.target.value });
    }
  };

  fileFormateIcon(file) {
    const fileDetails = file.name.split(".");
    if (fileDetails[1] === "txt") {
      return (
        <TEXT_ICON
          style="uploadWindow_Format_icon"
          altText="txt"
          id="text_icon"
        />
      );
    } else if (fileDetails[1] === "docx" || fileDetails[1] === "doc") {
      return (
        <WORD_ICON
          style="uploadWindow_Format_icon"
          altText="txt"
          id="word_icon"
        />
      );
    } else if (fileDetails[1] === "pdf") {
      return (
        <PDF_ICON
          style="uploadWindow_Format_icon"
          altText="txt"
          id="text_icon"
        />
      );
    } else if (
      fileDetails[1] === "xlsx" ||
      fileDetails[1] === "xls" ||
      fileDetails[1] === "ods" ||
      fileDetails[1] === "csv"
    ) {
      return (
        <EXCEL_ICON
          style="uploadWindow_Format_icon"
          altText="txt"
          id="excel_icon"
        />
      );
    }
  }

  deleteFile = (e, index) => {
    e.preventDefault();
    let temp1 = [...this.state.files];
    let temp2 = [...this.state.selectedValue];
    let deltFile = [];

    if (index > -1) {
      deltFile = temp1.splice(index, 1);
      temp2.splice(index, 1);
    }

    const replaceFlag =
      this.state.userMessage && deltFile[0]?.name === this.state.newFile?.name;

    if (replaceFlag) {
      this.setState({
        files: temp1,
        selectedValue: temp2,
        userMessage: false,
        disabled: false,
      });
    } else {
      this.setState({ files: temp1, selectedValue: temp2 });
    }
  };

  cancelButton(e) {
    this.setState({
      files: [],
      selectedValue: [],
      userMessage: false,
      selectValue: "",
      errMessage: "",
      disabled: false,
      selectDocument: [],
    });
    this.props.onHide();
  }

  replaceFiles() {
    const deft = [...this.state.files];
    const val = [...this.state.selectedValue];
    for (var i = 0; i < deft.length; i++) {
      if (deft[i].name === this.state.newFile.name) {
        formData.delete(val[i], deft[i]);
        deft.splice(i, 1);
        val.splice(i, 1);
      }
    }
    val.push(this.state.selectValue);
    deft.push(this.state.newFile);
    this.setState({
      userMessage: false,
      files: deft,
      selectedValue: val,
      disabled: false,
    });
  }

  sizeCalc = (size) => {
    if (size >= 1073741824) {
      size = (size / 1073741824).toFixed(2) + " GB";
    } else if (size >= 1048576) {
      size = (size / 1048576).toFixed(2) + " MB";
    } else if (size >= 1024) {
      size = (size / 1024).toFixed(2) + " KB";
    } else if (size > 1) {
      size = size + " bytes";
    } else if (size === 1) {
      size = size + " byte";
    } else {
      size = "0 byte";
    }

    return size;
  };

  handleClose = () => {
    this.setState({ extensionFlag: false });
  };

  fileSizeErrorHandleClose = () => {
    this.setState({
      showFileSizeErrorModal: false,
    });
  };

  fileSizeErrorHandleSubmit = () => {
    let tempFiles = [...this.state.files];
    let selectedValue = [...this.state.selectedValue];
    let delIndex = [];
    tempFiles = tempFiles.filter((item, i) => {
      formData.delete(selectedValue[i], tempFiles[i]);
      if (item.size > fileSizeLimit) {
        delIndex.push(i);
        return false;
      }
      return true;
    });

    selectedValue = selectedValue.filter((value, i) => {
      return !delIndex.includes(i);
    });

    this.setState({
      showFileSizeErrorModal: false,
      files: tempFiles,
      selectedValue: selectedValue,
    });
  };

  rolePermissionForAddDocumentConsignmentContractFirstDraft = () =>
    getUserRolePermission(
      rolePermConsts.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
      rolePermConsts.VMP_ADDDOCUMENT_CONSIGNMENT_CONTRACT_FIRST_DRAFT
    );

  rolePermissionForChannelProfitCalculator = () =>
    getUserRolePermission(
      rolePermConsts.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
      rolePermConsts.VMP_ADDDOCUMENT_CHANNEL_PROFIT_CALCULATOR
    );
  onChange = (e) => {
    let expirationErrorMsg = !isValidateDateField(e.target.value)
      ? Constants.MBE_WBE_EXPIRATION_DATE_ERROR_MESSAGE
      : "";
    this.setState({
      expirationDate: e.target.value,
      expirationErrorMsg: expirationErrorMsg,
    });
  };
  getExpiryDateSelected = () => {
    const { vendorDetail = {} } = this.props.vendorProfile || {};
    if (
      this.state.selectValue === Constants.MINORITY_BUSINESS_DOCUMENTATION &&
      isAllowToShowExipryDate === rolePermConsts.EDIT &&
      !vendorDetail.isAffidavit &&
      checkOnBoardingStatus(this.props.onboardingStatus, [Constants.LIVE])
    ) {
      if (!this.state.expirationDate || this.state.expirationErrorMsg) {
        return true;
      }
    }
    return false;
  };
  showExpirationDate = () => {
    const { vendorDetail = {} } = this.props.vendorProfile || {};
    const {
      isPrimaryVendor,
      certifiedAsMinority,
      merchandiseType = "",
      isAffidavit,
    } = vendorDetail;
    const isShowExpirationField =
      this.state.selectValue === "MinorityBusinessDocumentation" &&
      isAllowToShowExipryDate === rolePermConsts.EDIT &&
      !isAffidavit &&
      merchandiseType !== Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
      isPrimaryVendor &&
      certifiedAsMinority &&
      checkOnBoardingStatus(this.props.onboardingStatus, [Constants.LIVE]);
    return isShowExpirationField;
  };

  render() {
    const fileExtension = [
      ".DOC (or .DOCX)",
      ".JPG (or .JPEG)",
      ".ODT",
      ".PDF",
      ".PNG",
      ".XLS (or .XLSX)",
      ".XLSM",
    ];

    return (
      <div>
        {this.state.showFileSizeErrorModal && (
          <DocumentUploadFileSizeErrorModal
            open={this.state.showFileSizeErrorModal}
            handleClose={this.fileSizeErrorHandleClose}
            handleSubmit={this.fileSizeErrorHandleSubmit}
          />
        )}
        {this.state.extensionFlag && (
          <Modal
            className="exports-modal"
            show={this.state.extensionFlag}
            onHide={this.handleClose}
            backdrop="static"
          >
            <Modal.Header>
              <Modal.Title>Error – File Extension</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="uploadWindow-fileExtensionHeading">
                Please select a file with one of the following extensions:
              </div>
              {fileExtension.map((fileExt, i) => (
                <div key={`fileExt-${i}`}>{fileExt}</div>
              ))}
            </Modal.Body>
            <Modal.Footer>
              <Button className="button-primary-md" onClick={this.handleClose}>
                OK
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        <Modal
          {...this.props}
          onHide={this.cancelButton}
          contentClassName="uploadWindow-uploadModal"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Upload Document
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="uploadWindow-uploadModalBody">
            <Row className="show-grid">
              <Col xs={12} md={6}>
                <Row>
                  <select
                    id="selectCategory"
                    className="drop_downBox marginTop20 uploadWindow-selectBox"
                    onChange={(e) => this.filevalue(e, "Document Category")}
                  >
                    <option value="" selected hidden>
                      Select Document Category
                    </option>
                    <option value="AccountsPayableDocuments">
                      Accounts Payable Documents
                    </option>
                    <option value="PreboardingDocuments">
                      Preboarding Documents
                    </option>
                    <option value="IntegrationDocuments">
                      Integration Documents
                    </option>
                    <option value="MiscDocuments">Misc. Documents</option>
                  </select>
                </Row>
                <Row>
                  <select
                    id="selectDocument"
                    className="drop_downBox marginTop20 uploadWindow-selectBox"
                    onChange={(e) => this.filevalue(e, "Select Document")}
                    disabled={!this.state.selectDocument?.length > 0}
                  >
                    <option value="" selected hidden>
                      Select Document
                    </option>
                    {this.state.selectDocument &&
                      this.state.selectDocument.length > 0 &&
                      this.state.selectDocument.map((document, i) => {
                        return (
                          <option
                            key={`document-option-${i}`}
                            value={document.value}
                          >
                            {document.label}
                          </option>
                        );
                      })}
                  </select>
                </Row>
                {this.showExpirationDate() && (
                  <div>
                    <Form.Group className="expiry_date" as={Col} md={8} key={0}>
                      <ToolTip
                        toolTipId={"toolTipEndOfProgramDate"}
                        customStyles="compDetailsFormLabel"
                        label={"Enter MBE/WBE Expiration Date :"}
                        toolTipText={"Select Expiry Date."}
                        mandate={Constants.REQUIRED}
                      />
                      <Form.Control
                        type={"date"}
                        id={"expiryDateId"}
                        name={"expiryDateNAme"}
                        value={this.state.expirationDate || ""}
                        min={
                          new Date().getFullYear() +
                          "-" +
                          (new Date().getMonth() + 1)
                            .toString()
                            .padStart(2, "0") +
                          "-" +
                          new Date()
                            .getDate()
                            .toString()
                            .padStart(2, "0")
                        }
                        max={
                          new Date().getFullYear() +
                          200 +
                          "-" +
                          (new Date().getMonth() + 1)
                            .toString()
                            .padStart(2, "0") +
                          "-" +
                          new Date()
                            .getDate()
                            .toString()
                            .padStart(2, "0")
                        }
                        onChange={(e) => this.onChange(e)}
                      />
                    </Form.Group>
                    <div style={{ color: "red" }}>
                      {this.state.expirationErrorMsg}
                    </div>
                  </div>
                )}
                <Row></Row>
              </Col>
              <Col xs={12} md={6}>
                <div className="uploadWindow-dropDown">
                  <Dropzone
                    onFilesAdded={this.onFilesAdded}
                    pendingFiles={this.state.files}
                    disabled={
                      this.state.disabled || this.getExpiryDateSelected()
                    }
                    replaceFlag={this.state.userMessage}
                  />
                </div>
              </Col>
            </Row>

            <Row className="show-grid">
              <Col>
                {this.state.files && (
                  <div className="uploadWindow-Files">
                    {this.state.files.map((file, index) => {
                      return (
                        <div key={`${file.name}-${index}-file-list`}>
                          {this.fileFormateIcon(file)}
                          <span className="uploadWindow-Filename">
                            {this.state.selectedValue[index]}_{file.name}(
                            {this.sizeCalc(file.size)}
                            ).
                            <span
                              className="uploadWindow_Delete_files"
                              onClick={(e) => this.deleteFile(e, index)}
                            >
                              X
                            </span>
                          </span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </Col>
              <Col className="uploadWindow-fileExtension">
                <div className="uploadWindow-fileExtensionHeading">
                  The following file extensions are accepted:
                </div>
                {fileExtension.map((fileExt, i) => (
                  <div key={`fileExt-opt-${i}`}>{fileExt}</div>
                ))}
              </Col>
            </Row>
            <Row className="show-grid">
              <Col>
                <div className="uploadWindow_userInfo_txt">
                  {this.state.userMessage && (
                    <span>
                      <strong>{this.state.newFile.name}</strong> already
                      uploaded into the system, you would like to replace the
                      existing document
                    </span>
                  )}
                  {this.state.errMessage !== "" && (
                    <span>{this.state.errMessage}</span>
                  )}
                </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer className="uploadWindow-uploadModalFooter">
            <Row className="uploadWindow_footer_row">
              <Col>
                <div className="floatRight">
                  {!this.state.userMessage ? (
                    <Button
                      className="button-primary-md"
                      onClick={this.uploadFilesBtn}
                      disabled={
                        (this.state.files.length === 0 ? true : false) ||
                        this.state.disableUploadButton ||
                        this.getExpiryDateSelected()
                      }
                    >
                      Upload
                    </Button>
                  ) : (
                    <Button
                      className="button-primary-md"
                      onClick={this.replaceFiles}
                    >
                      Replace
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = ({ service }) => ({
  vendorProfile: service.vendorProfile,
});

const mapDispatchToProps = (dispatch) => {
  return {
    updateServiceData: (data) => dispatch(updateServiceData(data)),
    updateCommonInfo: (data) => dispatch(updateCommonInfo(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Uploadwindow);
